export default __webpack_public_path__ + "static/media/loading.5fb16547.gif";